import { Button, Form, Input, message, Modal, Select } from 'antd';
import { getSelectList, SelectList, SelectPayload, SelectResponse } from 'api/dashboard';
import { addAdmin, AddAdminPayload, UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import AddUser from '../AddUser';

// const Options = SelectProps['Options'] = [];
const { Option } = Select;
const inituser: UserPayload = {};
const initSelectResp: SelectResponse = {
  data: [],
};
const initPartners: SelectList[] = [];

const AddAdmin = () => {
  const [form] = Form.useForm<AddAdminPayload>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(inituser);
  const [sources, setSource] = useState(initSelectResp);
  const [_sourceId, setSourceId] = useState(0);
  const [_statusId, setStatusId] = useState(0);
  const [statusList, setStatus] = useState(initPartners);

  useEffect(() => {
    // setAdmin(adminRole);
    const sourcePayload: SelectPayload = {
      SKey: 'Source',
    };
    // setIsLoading(false);
    getSelectList(sourcePayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setSource(res);
    });

    const statusPayload: SelectPayload = {
      SKey: 'LoanType',
    };

    // setIsLoading(false);
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });
  }, []);

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };

  const handleLoanId = (e: any) => {
    // debugger;
    // form.setFieldValue('statusId', e);
    // form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSubmit = useCallback(
    async (_values: AddAdminPayload) => {
      // if (user.userId == null) message.warn('Please create an admin user first!');
      // else {
      _values.userId = user.userId;
      _values.loanTypes = _values.loanTypes?.toString();
      debugger;
      addAdmin(_values).then((x) => {
        if (x.data) {
          message.success('Partner ' + x.data.partnerName + ' has been created successfully!');
        }
      });
      setUser(inituser);
      form.resetFields();
      // }
    },
    [form, user]
  );
  const handleReset = async (_e: any) => {
    setUser(inituser);
    form.resetFields();
  };

  // const handleAddUser = () => {
  //   setIsModalOpen(true);
  // };

  const handleUserSubmit = useCallback(
    async (payload: UserPayload) => {
      let userData = { ...user };
      userData = payload;
      setUser(userData);
      console.log(user);
      setIsModalOpen(false);
    },
    [user]
  );

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div>
        <div className="container">
          <div className="row">
            <div className="col-xs-8 col-sm-8 col-md-8 offset-md-2">
              <div className="mid-container">
                <div className="submission-box">
                  <h2>Add Partner</h2>
                  <div className="submission-htmlForm">
                    {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                    <Form<AddAdminPayload>
                      form={form}
                      onFinish={handleSubmit}
                      layout="vertical"
                      scrollToFirstError
                      className="standard-forms"
                    >
                      <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6">
                          <div className="input-box">
                            <Form.Item
                              label={'Partner Name :'}
                              name="partnerName"
                              className="fieldTitle"
                            >
                              <Input placeholder={'Partner Name'} />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6">
                          <div className="input-box">
                            {/* <Form.Item label={'Source Application Name :'} name="sourceId">
                              <Select defaultValue="0" size="large">
                                <Option value="0">Select</Option>
                                <Option value="E562EAD8-E256-424A-A792-037AAD9DD7A9">
                                  AXISBBPS
                                </Option>
                                <Option value="AD352334-DD0B-4132-8730-19E54372D2C5">
                                  PayNearBy
                                </Option>
                                <Option value="07F40AB8-6124-8946-B1A4-1A8136C0FE53">
                                  Softcell
                                </Option>
                                <Option value="ACA68C44-A693-4B3F-8260-202812232A27">JODO</Option>
                                <Option value="28D519AF-FD78-455A-946D-286EE2365701">
                                  Credenc
                                </Option>
                                <Option value="0B06A4EE-8F88-4A66-BD07-28A763AEB1CA">Spoor</Option>
                                <Option value="9ABF4750-6BD0-466B-8571-2F109A8231DA">
                                  FinancePeer
                                </Option>
                                <Option value="B058AB33-4D76-4129-9084-34A940171D8B">
                                  Corporate Website
                                </Option>
                                <Option value="60DC8FF8-AB84-423E-9084-3D7BDE26996F">
                                  OverdueSchedular
                                </Option>
                                <Option value="0E0FC5D1-D4A1-4A23-9116-42956785FB9D">test</Option>
                                <Option value="E2AC3EEA-6649-4B54-A486-492D29E5B3EA">
                                  Techfino
                                </Option>
                                <Option value="3FD2B938-55DD-44DD-B013-60D4E4D00F70">CRM</Option>
                                <Option value="A1CE4D91-4C88-4CE2-9061-61CC308C5CFE">
                                  Credit Fair
                                </Option>
                                <Option value="0766DFD2-79BE-49AF-87D6-719A96CDC0DB">
                                  PaymentModule
                                </Option>
                                <Option value="05546C95-9322-4226-BA25-7E0C4284AC03">Ebix</Option>
                                <Option value="41EDA16E-3F1B-4699-96FE-7E1120FD5D04">
                                  Customer Portal
                                </Option>
                                <Option value="B2593314-EBF0-4CAD-BCDE-89D6356CF5F8">
                                  Gyandhan
                                </Option>
                                <Option value="46F8A9B9-BA58-455C-B9AA-9C4BA8BEAAD0">
                                  Fino Payments
                                </Option>
                                <Option value="E896C4F5-46A3-4B7E-B6A9-A93B75FE5211">cxcx</Option>
                                <Option value="C8D97467-8B2D-4079-975A-ADC821AB5D1F">
                                  Algo collect
                                </Option>
                                <Option value="FEDA2D74-07C0-4650-89E0-BC67D9FEC739">AXIS</Option>
                                <Option value="1A3C9AE3-9C6C-4121-9C07-C3AB383E39C4">Kelton</Option>
                                <Option value="1CB2FEA9-F3C3-4AAC-8311-E8C8262193F9">
                                  School Fees
                                </Option>
                                <Option value="9605DC50-94BA-43CC-833E-EC6850603784">
                                  Finwego
                                </Option>
                                <Option value="40639B66-7362-43CA-9E3E-FB77E83BC0D6">AGENT</Option>
                              </Select>
                            </Form.Item> */}
                            <Form.Item
                              label={'Source Application Name :'}
                              name="sourceId"
                              className="fieldTitle"
                            >
                              <Select placeholder="Select" size="large" onSelect={handleSourceId}>
                                {sources.data.map((role) => (
                                  <Option value={role.SValue}>{role.SText}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6">
                          <div className="input-box">
                            <Form.Item label={'Loan Type:'} name="loanTypes">
                              {/* <Select
                                placeholder="Please select loan type"
                                size="large"
                                mode="multiple"
                              >
                                <Option value="EL">EL</Option>
                                <Option value="EIL">EIL</Option>
                                <Option value="BLPREAPP">BLPREAPP</Option>
                                <Option value="BLSME">BLSME</Option>
                                <Option value="DIGPL">DIGPL</Option>
                                <Option value="DIGPRO">DIGPRO</Option>
                                <Option value="DIGPRO1">DIGPRO1</Option>
                                <Option value="ELDOMC">ELDOMC</Option>
                                <Option value="ELFORN">ELFORN</Option>
                                <Option value="LAPPREAP">LAPPREAP</Option>
                                <Option value="LAPSME">LAPSME</Option>
                                <Option value="PLPREAPP">PLPREAPP</Option>
                                <Option value="VOC">VOC</Option>
                                <Option value="MEL-CROSSSELL">MEL-CROSSSELL</Option>
                                <Option value="MEL-BL">MEL-BL</Option>
                                <Option value="MEL-PL">MEL-PL</Option>
                                <Option value="MEL-LAP">MEL-LAP</Option>
                                <Option value="SME-LAP">SME-LAP</Option>
                                <Option value="SME-BL">SME-BL</Option>
                                <Option value="DIGTOP">DIGTOP</Option>
                                <Option value="SFFPESIL">SFFPESIL</Option>
                                <Option value="SSFGYA">SSFGYA</Option>
                                <Option value="EILGECL">EILGECL</Option>
                                <Option value="SILGECL">SILGECL</Option>
                                <Option value="SSFWESIL">SSFWESIL</Option>
                                <Option value="SSFGYAW">SSFGYAW</Option>
                                <Option value="SCHOOLFE">SCHOOLFE</Option>
                                <Option value="TESTPREP">TESTPREP</Option>
                                <Option value="TUTIONFE">TUTIONFE</Option>
                                <Option value="UPSKLNG">UPSKLNG</Option>
                                <Option value="DIGJODO">DIGJODO</Option>
                                <Option value="SFFCREFA">SFFCREFA</Option>
                                <Option value="SFTCPSIL">SFTCPSIL</Option>
                                <Option value="DIGPL1">DIGPL1</Option>
                                <Option value="SFEDUSIL">SFEDUSIL</Option>
                                <Option value="CSLOAN">CSLOAN</Option>
                                <Option value="SCFEIL">SCFEIL</Option>
                                <Option value="PAPL">PAPL</Option>
                                <Option value="PAVL">PAVL</Option>
                                <Option value="PAVL2">PAVL2</Option>
                                <Option value="DIGPRATI">DIGPRATI</Option>
                                <Option value="VOCGL">VOCGL</Option>
                              </Select> */}

                              <Select
                                placeholder="Please select loan type"
                                size="large"
                                mode="multiple"
                                onSelect={handleLoanId}
                              >
                                {statusList.map((status) => (
                                  <>
                                    <Option value={status.SValue}>{status.SText}</Option>
                                  </>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6">
                          {user.userId != null ? (
                            <>
                              <div className="input-box">
                                <Form.Item
                                  label={'Admin user :'}
                                  name="user"
                                  className="fieldTitle"
                                >
                                  <span style={{ color: 'green' }}>{user.emailID}</span>
                                  {/* <Input placeholder={user.emailID} value={user.emailID} disabled={true} color="green" /> */}
                                </Form.Item>
                              </div>
                            </>
                          ) : // : (
                          //   <div className="input-box" style={{ marginTop: '32px' }}>
                          //     <Button onClick={handleAddUser}>Add Admin User</Button>
                          //   </div>
                          null}
                        </div>
                      </div>
                      <Button
                        type="primary"
                        onClick={handleReset}
                        style={{ float: 'right', marginLeft: '15px', marginBottom: '10px' }}
                      >
                        {'CLEAR'}
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginBottom: '10px' }}
                      >
                        {'ADD'}
                      </Button>
                    </Form>
                  </div>
                  {/* <PaymentList filter={filter} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Create Partner Admin User"
        onOk={handleOk}
        onCancel={handleCancel}
        open={isModalOpen}
        width="50%"
        footer={[<div></div>]}
      >
        <AddUser onSubmit={handleUserSubmit} isAdmin={true} />
      </Modal>
    </>
  );
};

export default AddAdmin;
